import classNames from 'classnames';
import { HeatmapActivityOption } from '../../types/HeatmapActivity';
import { HeatmapTimeRangeOption } from '../../types/HeatmapTimeRange';
import type { Chip } from './OptionChip';
import OptionChip from './OptionChip';
import styles from './OptionChip.module.scss';

type SelectionChipsProps = {
  className?: string;
  chips?: Chip[];
  selectedChip?: Chip;
  title: string;
  onChange: (selectedChip: HeatmapActivityOption | HeatmapTimeRangeOption) => void;
};

const OptionChips = ({ className, chips, selectedChip, title, onChange }: SelectionChipsProps) => {
  return (
    <div className={classNames(styles.parentContainer, className)}>
      <div className={styles.selectionChipContainer} role="radiogroup" aria-labelledby={title}>
        {chips?.map((chip, index) => (
          <OptionChip
            chip={chip}
            key={chip.value}
            onClick={onChange}
            isSelected={selectedChip?.value === chip.value}
            index={index}
            totalNumberOfChips={chips.length}
          />
        ))}
      </div>
    </div>
  );
};

export default OptionChips;
